export const RouterSkeletonsTargetApps: Set<string> = new Set([
  "@cytiva/ap-training"
]);

export const RouteToSkeletonMap: { [key: string]: string } = {
  "/training/training-catalog/my-courses":
    "AP_TRAINING_CATALOG_MY_COURSES_LOADER",
  "/training/training-catalog/object": "AP_TRAINING_CATALOG_OBJECT_LOADER",
  "/training/training-catalog": "AP_TRAINING_CATALOG_LOADER",
  "/training": "AP_TRAINING_LOADER"
};

export const RouteToErrorSkeletonMap: { [key: string]: string } = {
  "/training/training-catalog/my-courses":
    "AP_TRAINING_CATALOG_MY_COURSES_LOADER",
  "/training/training-catalog/object": "AP_TRAINING_CATALOG_OBJECT_LOADER",
  "/training/training-catalog": "AP_TRAINING_CATALOG_LOADER",
  "/training": "AP_TRAINING_LOADER"
};
